module.exports = __webpack_public_path__ + "img/aaij-print-template-header.8540510a.png";